import CryptoJS from 'crypto-js'
export default function (data) {
  return CryptoJS.MD5(data).toString()
}
